import styled from 'styled-components';
import { hexa } from 'styles/utils';

export const StickyWrapper = styled.div`
  position: fixed;
  right: 0px;
  bottom: 0px;
  left: 0px;
  width: 100%;
  z-index: 10;
  opacity: ${props => (props.visible ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
  background-color: ${hexa('#ffffff', 0.75)};
`;
